import { ROLE_META, ROLE_ORDER } from '@/lib/subscription';

interface RoleTabsProps {
  activeRole: string;
  onChange: (role: string) => void;
}

function RoleTabs({ activeRole, onChange }: RoleTabsProps) {
  return (
    <div className="inline-flex flex-wrap items-center gap-1 bg-background-100 border border-background-200/70 rounded-full p-1">
      {ROLE_ORDER.map((role) => {
        const meta = ROLE_META[role];
        if (!meta) return null;
        const active = activeRole === role;
        return (
          <button
            key={role}
            type="button"
            onClick={() => onChange(role)}
            className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
              active ? 'bg-primary-500 text-foreground-950' : 'text-foreground-600 hover:text-foreground-50'
            }`}
          >
            <i className={meta.icon} />
            {meta.label}
          </button>
        );
      })}
    </div>
  );
}

export default RoleTabs;